import findBlockedElements from './findBlockedElements'
import releaseNodes from './releaseNodes'
import unblockAndReplaceNode from './unblockAndReplaceNode'


export function unblockAll() {
  unblockTree(document.documentElement)
}

/**
 * @param {string} urlSubstring
 */
export function unblockByURLSubstring(urlSubstring, config) {
  const selector = ['data-src', 'data-href']
    .map((attr) => `[${ attr }*='${ urlSubstring }']`)
    .join(',')

  querySelectorAll(selector)
    .forEach((node) => {
      unblockAndReplaceNode(node, config)
    })
}

/**
 * @param {(string[]|Set<string>)} categories
 */
export function unblockByCategory(categories) {
  unblockTree(document.documentElement, categories)
}

/**
 * Unblocks the manually-blocked elements at or beneath a subtree that turned
 * up after the sweep.
 *
 * Auto-blocked elements are left alone. The AutoBlocker decides those as they
 * are inserted, and by a different test than this one, so re-deciding them
 * here would either overrule it or leave the two of us undoing each other's
 * work for the life of the page.
 *
 * @param {Element} root
 * @param {(string[]|Set<string>)} [categories] - when omitted, every blocked
 *   element is released, whatever categories it declares
 */
export function unblockAddedTree(root, categories) {
  const nodes = findBlockedElements(root)
    .filter((node) => !isAutoBlocked(node))

  releaseNodes(nodes, categories)
}

function isAutoBlocked(node) {
  return Boolean(node.dataset.autoblocked)
}

/**
 * Unblocks every blocked element at or beneath `root`, manually-blocked or
 * auto-blocked alike. This is the sweep a consent decision runs, so it has to
 * reach the AutoBlocker's elements too.
 *
 * @param {Element} root
 * @param {(string[]|Set<string>)} [categories] - when omitted, every blocked
 *   element is released, whatever categories it declares
 */
function unblockTree(root, categories) {
  releaseNodes(findBlockedElements(root), categories)
}

function querySelectorAll(query) {
  return Array.from(document.querySelectorAll(query))
}
